import React, { useEffect, Fragment } from "react";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import Traductor from "../components/Traductor";
import ScrollToTop from "../components/ScrollToTop";

var accordionStyle = {
  height: "0px",
  visibility: "hidden",
  overflowY: "hidden",
};

const LegalNotePage = () => {
  const t = new Traductor();

  useEffect(() => {
    window.bronson.$$(".c-accordion").component("accordion");
  }, []);

  return (
    <Fragment>
      <ScrollToTop></ScrollToTop>
      <div
        className="c-hero-teaser c-hero-teaser--no-image c-hero-teaser--auto"
        data-testid="legalNotePageTestId"
      >
        <div className="c-hero-teaser__image"></div>
        <div
          id="js-hero-teaser-content"
          className="c-hero-teaser__content u-pt-small u-mt-none"
        >
          <div className="c-hero-teaser__content-inner">
            <header className="c-hero-teaser__heading">
              <div className="c-hero-teaser__title">
                <h1>
                  <span className="c-hero-teaser__title-row">
                    {t.getTraduction("LegalNote")}
                  </span>
                  <br />
                </h1>
              </div>
            </header>
          </div>
        </div>
      </div>

      <main className="o-main  ">
        <section className="o-content-section  u-pt-none">
          <div className="o-page-wrap  o-page-wrap--xxsmall">
            <div className="c-accordion js-accordion js-is-fx js-is-ready">
              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Quiénes somos
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          El presente sitio web (en adelante, el "Sitio
                          Web")&nbsp;
                          <a
                            href="http://www.volkswagenfinancialservices.es/content/sites/vwcorporate/volkswagenfinance_es/es/home.html"
                            title="vwfs"
                          >
                            www.vwfs.es
                          </a>
                          &nbsp;regula la prestación de determinados servicios
                          que las filiales del GrupoVolkswagen realizan en
                          España bajo el nombre comercial "Volkswagen Financial
                          Services". En particular, los servicios financieros y
                          bancarios son prestados a través de Volkswagen Bank
                          GmbH S.E.; los servicios de renting a través de
                          Volkswagen Renting S.A.; los servicios de seguros y
                          mediación de seguros a través de Volkswagen
                          Versicherung A.G. y Volkswagen Insurance Services
                          Correduría de Seguros S.L., respectivamente, y los
                          servicios de movilidad, entre otras, a través de
                          Volkswagen Renting S.A.
                        </p>
                        <p>
                          El Sitio Web es titularidad de las siguientes
                          compañías:
                        </p>
                        <br />
                        <p>
                          <b>VOLKSWAGEN BANK GMBH Sucursal en España .E.</b>
                        </p>
                        <p>
                          <b>Calle:</b>&nbsp;Avda. de Bruselas 34 - 28108
                          Alcobendas (Madrid)
                        </p>
                        <p>
                          <b>Correo electrónico:</b>&nbsp;
                          <a
                            href="mailto:atencion.cliente@vwfs.com"
                            target="_self"
                          >
                            atencion.cliente@vwfs.com
                          </a>
                        </p>
                        <p>
                          <b>C.I.F:</b>&nbsp;CIF W0042741I
                        </p>
                        <p>
                          <b>Telf.:</b>&nbsp;
                          <a href="tel:914279900" title="914279900">
                            91 427 99 00
                          </a>
                        </p>
                        <p>
                          Datos mercantiles: Registro Mercantil de la provincia
                          de Madrid. Tomo 16.828, folio 184, hoja M-287573
                          Inscrita con el nº 1480 Registro Especial del Banco de
                          España.
                        </p>
                        <br />
                        <p>
                          <b>VOLKSWAGEN RENTING, S.A.</b>
                        </p>
                        <p>
                          <b>Calle:</b>&nbsp;Avda. Bruselas 34 – 28108
                          Alcobendas (Madrid)
                        </p>
                        <p>
                          <b>Correo electrónico:</b>&nbsp;
                          <a href="mailto:vwleasing@vwfs.com" target="_self">
                            vwleasing@vwfs.com
                          </a>
                        </p>
                        <p>
                          <b>C.I.F:&nbsp;</b>A80/185051
                        </p>
                        <p>
                          <b>Telf.:</b>&nbsp;
                          <a
                            href="tel:914279903"
                            target="_self"
                            title="91 427 99 03"
                          >
                            91 427 99 03
                          </a>
                        </p>
                        <p>
                          Datos mercantiles: Registro Mercantil de la provincia
                          de Madrid. Tomo 2.138. Folio 63. Hoja nº M-37860.
                          Inscripción 1ª.
                        </p>
                        <br />
                        <p>
                          <b>
                            VOLKSWAGEN INSURANCE SERVICES CORREDURÍA DE SEGUROS,
                            S.L.
                          </b>
                        </p>
                        <p>
                          <b>Calle:&nbsp;</b>Avda. Baix Llobregat 8 1ª planta El
                          Prat de Llobregat (Barcelona)
                        </p>
                        <p>
                          <b>Correo electrónico:</b>&nbsp;
                          <a href="mailto:infovwis@vwfs.com" target="_self">
                            infovwis@vwfs.com
                          </a>
                        </p>
                        <p>
                          <b>C.I.F:</b>&nbsp;B-28007615
                        </p>
                        <p>
                          <b>Telf.:</b>&nbsp;
                          <a
                            href="tel:934443311"
                            target="_self"
                            title="93 444 33 11"
                          >
                            93 444 33 11
                          </a>
                        </p>
                        <p>
                          Datos mercantiles: Registro Mercantil de Barcelona,
                          Tomo 31795 Folio 0139, Hoja 14157, Inscripción 2ª, e
                          Inscrita en el Registro Especial de Mediadores la
                          Dirección General de Seguros con la clave J0667,
                          teniendo concertados los Seguros de Responsabilidad
                          Civil y de Caución, según Ley 26/2006, de 17 de julio.
                        </p>
                        <p>
                          El grupo Volkswagen se considera a sí mismo vinculado
                          no solo por normas legales sino también por las normas
                          internas. Los compromisos y principios éticos son
                          parte esencial de nuestra cultura corporativa,
                          proporcionando un marco de referencia para la toma de
                          decisiones. Estamos convencidos de que el éxito
                          económico sostenible sólo puede estar amparado por
                          normas y reglas internas. En nuestro trabajo diario
                          apostamos por un comportamiento honesto que cumpla con
                          las normas.&nbsp;
                        </p>
                        <p>
                          Nos aseguramos del respeto y concienciación por parte
                          de los empleados de las normas internas, y contamos
                          con medidas preventivas adecuadas para su integración
                          en el sistema de gestión actual. Sin embargo, somos
                          conscientes de que no es posible excluir totalmente el
                          riesgo de conductas individuales, por lo que hemos
                          creado una red de cumplimiento en todo el grupo
                          Volkswagen, que reúne la experiencia de los oficiales
                          de cumplimiento en las marcas y empresas y de diversos
                          organismos del grupo.
                        </p>
                        <p>
                          ¿Qué entendemos por cumplimiento normativo? La
                          observancia de las disposiciones legales, las
                          políticas internas de la empresa y los principios
                          éticos.
                        </p>
                        <p>
                          El código de conducta contiene los principios básicos
                          esenciales, proporciona orientación y fomenta el
                          comportamiento correcto por parte de todos los
                          empleados en su trabajo diario.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Aceptación por el usuario
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          El presente aviso legal regula el uso de esta página
                          web puesta a disposición de los usuarios en la
                          URL&nbsp;
                          <a
                            title="vwfs"
                            href="http://www.volkswagenfinancialservices.es/content/sites/vwcorporate/volkswagenfinance_es/es/home.html"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            www.vwfs.es.
                          </a>{" "}
                          Cualquier uso de la presente web le otorga la
                          condición de Usuario de la misma y supone su plena
                          aceptación a las condiciones recogidas en este aviso
                          legal.
                        </p>
                        <p>
                          VOLKSWAGEN FINANCIAL SERVICES realiza continuos
                          esfuerzos para evitar errores en los contenidos que
                          pudieran aparecer en este web site. VOLKSWAGEN
                          FINANCIAL SERVICES no garantiza, ni se responsabiliza
                          de las consecuencias que pudieran derivarse de los
                          errores en los contenidos que pudieran aparecer en
                          este web site, proporcionados por terceros, asimismo
                          no asume responsabilidad alguna por las discrepancias
                          que pudiesen existir entre los documentos impresos y
                          la versión electrónica publicada en este web site. En
                          caso de discrepancia entre la versión impresa y la
                          publicada en el web site, prevalecerá la versión
                          impresa, salvo lo establecido respecto a erratas y
                          actualizaciones.&nbsp;La información contenida o
                          facilitada por este sitio tiene finalidades
                          exclusivamente informativas no constituyendo oferta
                          alguna de servicios financieros o de servicios de
                          cualquier otro tipo. Este sitio no debe ser usado o
                          entendido como sustituto de la información que se le
                          facilite en el marco de una oferta de algún producto.
                          La información contenida en este sitio no supone un
                          compromiso por parte de VOLKSWAGEN FINANCIAL SERVICES
                          y no puede ser considerada como una oferta en firme de
                          ningún producto de financiación, renting, servicios
                          bancarios o de mediación en seguros.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Uso correcto del sitio web
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          El Usuario se compromete a utilizar la Web, los
                          contenidos y servicios de conformidad con la Ley, la
                          presente nota legal, las buenas costumbres y el orden
                          público. Del mismo modo el Usuario se obliga a no
                          utilizar la Web o los servicios que se presten a
                          través de él con fines o efectos ilícitos o contrarios
                          al contenido del presente nota legal, lesivos de los
                          intereses o derechos de terceros, o que de cualquier
                          forma pueda dañar, inutilizar o deteriorar la Web o
                          sus servicios o impedir un normal disfrute del Web por
                          otros Usuarios.
                        </p>
                        <p>
                          Asimismo, el Usuario se compromete expresamente a no
                          destruir, alterar, inutilizar o, de cualquier otra
                          forma, dañar los datos, programas o documentos
                          electrónicos y demás que se encuentren en la Web.
                        </p>
                        <p>
                          De igual forma, el Usuario se compromete a no
                          obstaculizar el acceso de otros usuarios al servicio
                          de acceso mediante el consumo masivo de los recursos
                          informáticos a través de los cuales VOLKSWAGEN
                          FINANCIAL SERVICES presta el servicio, así como
                          realizar acciones que dañen, interrumpan o generen
                          errores en dichos sistemas.
                        </p>
                        <p>
                          El Usuario se compromete a no introducir programas,
                          virus, macros, applets, controles ActiveX o cualquier
                          otro dispositivo lógico o secuencia de caracteres que
                          causen o sean susceptibles de causar cualquier tipo de
                          alteración en los sistemas informáticos de VOLKSWAGEN
                          FINANCIAL SERVICES. o de terceros.
                        </p>
                        <p>
                          El Usuario se compromete a no obtener informaciones,
                          mensajes, gráficos, dibujos, archivos de sonido y/o
                          imagen, fotografías, grabaciones, software y en
                          general, cualquier clase de material accesible a
                          través del Web o de los servicios ofrecidos en el
                          mismo.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Acceso al Sitio Web y contraseñas
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          El acceso al Sitio Web por parte de los usuarios tiene
                          carácter libre y gratuito.
                        </p>
                        <p>
                          Cuando sea necesario que el Usuario se registre o
                          aporte datos personales, a la recogida y el
                          tratamiento de los datos personales de los usuarios
                          será de aplicación lo dispuesto en el apartado 7 de
                          esta Nota Legal.
                        </p>
                        <p>
                          Queda prohibida la contratación a través del Sitio Web
                          por parte de menores de edad.
                        </p>
                        <p>
                          Cuando sea necesario que el Usuario se registre, será
                          responsable de aportar información veraz y lícita. Si
                          como consecuencia del registro, se dotara al Usuario
                          de una contraseña, éste se compromete a hacer un uso
                          diligente y a mantener en secreto la contraseña. Los
                          Usuarios son responsables de la adecuada custodia y
                          confidencialidad de cualesquiera identificadores y/o
                          contraseñas que le sean suministradas por VOLKSWAGEN
                          FINANCIAL SERVICES y se comprometen a no ceder su uso
                          a terceros, ya sea temporal o permanente, ni a
                          permitir su acceso a personas ajenas. Será
                          responsabilidad del Usuario la utilización del Sitio
                          Web por cualquier tercero ilegítimo que emplee a tal
                          efecto una contraseña a causa de una utilización no
                          diligente o de la pérdida de la misma por el Usuario.
                        </p>
                        <p>
                          El Usuario está obligado a notificar de forma
                          inmediata a VOLKSWAGEN FINANCIAL SERVICES cualquier
                          hecho que permita el uso indebido de los
                          identificadores y/o contraseñas, tales como el robo,
                          extravío, o el acceso no autorizado a los mismos, con
                          el fin de proceder a su inmediata cancelación.
                          Mientras no se comuniquen tales hechos VOLKSWAGEN
                          FINANCIAL SERVICES quedará eximida de cualquier
                          responsabilidad que pudiera derivarse del uso indebido
                          de los identificadores y/o contraseñas por terceros no
                          autorizados.&nbsp;
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Propiedad intelectual
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          Todos los contenidos del Web, salvo que se indique lo
                          contrario, son titularidad exclusiva de VOLKSWAGEN
                          FINANCIAL SERVICES o de terceros que han autorizado su
                          inclusión en el Web y, con carácter enunciativo, que
                          no limitativo, el diseño gráfico, código fuente,
                          logos, textos, ilustraciones, fotografías, y demás
                          elementos que aparecen en el Web.
                        </p>
                        <p>
                          Igualmente, todos los nombres comerciales, marcas o
                          signos distintivos de cualquier clase contenidos en el
                          Web están protegidos por la Ley.
                        </p>
                        <p>
                          VOLKSWAGEN FINANCIAL SERVICES no concede ningún tipo
                          de licencia o autorización de uso personal al Usuario
                          sobre sus derechos de propiedad intelectual e
                          industrial o sobre cualquier otro derecho relacionado
                          con su Web; y los servicios ofrecidos en la misma.
                        </p>
                        <p>
                          Por ello, el Usuario reconoce que la reproducción,
                          distribución, comercialización o transformación no
                          autorizadas de los elementos indicados en los
                          apartados anteriores constituye una infracción de los
                          derechos de propiedad intelectual y/o industrial de
                          VOLKSWAGEN FINANCIAL SERVICES o del titular de los
                          mismos.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Régimen de responsabilidad
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          <b>a. Responsabilidad por el uso del Web</b>
                        </p>
                        <p>
                          El Usuario es el único responsable de las infracciones
                          en las que pueda incurrir o de los perjuicios que
                          pueda causar o causarse por la utilización del Web,
                          quedando VOLKSWAGEN FINANCIAL SERVICES exonerada de
                          cualquier clase de responsabilidad que se pudiera
                          derivar por las acciones del Usuario. El Usuario es el
                          único responsable frente a cualquier reclamación o
                          acción legal, judicial o extrajudicial, iniciada por
                          terceras personas contra VOLKSWAGEN FINANCIAL SERVICES
                          basada en la utilización por el Usuario del Web. En su
                          caso, el Usuario asumirá cuantos gastos, costes e
                          indemnizaciones sean irrogados a VOLKSWAGEN FINANCIAL
                          SERVICES con motivo de tales reclamaciones o acciones
                          legales.
                        </p>
                        <p>
                          <b>
                            b. Responsabilidad por el funcionamiento del Web
                          </b>
                        </p>
                        <p>
                          VOLKSWAGEN FINANCIAL SERVICES excluye toda
                          responsabilidad que se pudiera derivar de
                          interferencias, omisiones, interrupciones, virus
                          informáticos, averías telefónicas o desconexiones en
                          el funcionamiento operativo del sistema electrónico,
                          motivado por causas ajenas a VOLKSWAGEN FINANCIAL
                          SERVICES. Asimismo,&nbsp;VOLKSWAGEN FINANCIAL SERVICES
                          también excluye cualquier responsabilidad que pudiera
                          derivarse por retrasos o bloqueos en el funcionamiento
                          operativo de este sistema electrónico causado por
                          deficiencias o sobre carga en las líneas telefónicas o
                          en Internet, así como de daños causados por terceras
                          personas mediante intromisiones ilegitimas fuera del
                          control de VOLKSWAGEN FINANCIAL SERVICES.
                        </p>
                        <p>
                          <b>c. Responsabilidad por links</b>
                        </p>
                        <p>
                          VOLKSWAGEN FINANCIAL SERVICES declina toda
                          responsabilidad respecto a la información que se halle
                          fuera del Web ya que la función de los links que
                          puedan aparecer es únicamente la de informar al
                          Usuario sobre la existencia de otras fuentes de
                          información sobre un tema en concreto.
                        </p>
                        <p>
                          VOLKSWAGEN FINANCIAL SERVICES se exonera de toda
                          responsabilidad por el correcto funcionamiento de
                          tales enlaces, del resultado obtenido a través de
                          dichos enlaces, de la veracidad y licitud del
                          contenido o información a la que se puede acceder así
                          como de los perjuicios que pueda sufrir en virtud de
                          la información encontrada en el Web enlazado.
                        </p>
                        <p>
                          <b>d. Responsabilidad por publicidad</b>
                        </p>
                        <p>
                          Parte del Web puede albergar contenidos publicitarios
                          o estar patrocinado. Los anunciantes y patrocinadores
                          son los únicos responsables de asegurarse que el
                          material remitido para su inclusión en el Web cumple
                          con las leyes que en cada caso puedan ser de
                          aplicación. VOLKSWAGEN FINANCIAL SERVICES no será
                          responsable de cualquier error, inexactitud o
                          irregularidad que puedan albergar los contenidos
                          publicitarios o de los patrocinadores.
                        </p>
                        <p>
                          En todo caso, para interponer cualquier reclamación
                          relacionada con los Contenidos publicitarios
                          insertados en este Web pueden dirigirse a la siguiente
                          dirección de correo electrónico:{" "}
                          <a
                            href="mailto:atencion.cliente@vwfs.com"
                            target="_self"
                          >
                            atencion.cliente@vwfs.com
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Tratamiento de los datos obtenidos a través de la web
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          A través de los formularios incluidos en el Sitio Web
                          se procederá a recabar los datos de los Usuarios tras
                          haber prestado su oportuno consentimiento. Para mayor
                          información diríjase a la cláusula incluida en cada
                          uno de los formularios.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Modificaciones del aviso legal
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          VOLKSWAGEN FINANCIAL SERVICES se reserva el derecho a
                          modificar unilateralmente en cualquier momento y sin
                          aviso previo, la presentación y configuración de este
                          Web, así como los servicios y condiciones requeridas
                          para usar el Web y sus servicios.
                        </p>
                        <p>
                          El Usuario quedará obligado automáticamente por el
                          Aviso Legal que se halle vigente en el momento en que
                          acceda al Web, por lo que deberá leer periódicamente
                          dicho Aviso Legal.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Confidencialidad
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          VOLKSWAGEN FINANCIAL SERVICES se compromete al
                          cumplimiento de su obligación de secreto de los datos
                          de carácter personal y de su deber de guardarlos de
                          forma confidencial y adoptará las medidas necesarias
                          para evitar su alteración, pérdida, tratamiento o
                          acceso no autorizado, habida cuenta en todo momento
                          del estado de la tecnología.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Observaciones del usuario
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          El Usuario garantiza que la información, material,
                          contenidos u observaciones que no sean sus propios
                          datos personales y que sean facilitados
                          a&nbsp;VOLKSWAGEN FINANCIAL SERVICES a través del Web,
                          no infringen los Derechos de Propiedad Intelectual o
                          Industrial de terceros, ni ninguna otra disposición
                          legal.
                        </p>
                        <p>
                          La información, materiales, contenidos u observaciones
                          que el Usuario facilite a VOLKSWAGEN FINANCIAL
                          SERVICES se considerarán no confidenciales,
                          reservándose VOLKSWAGEN FINANCIAL SERVICES el derecho
                          a usarlas de la forma que considere más adecuada.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Legislación aplicable y competencia judicial
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          Cualquier controversia surgida de la interpretación o
                          ejecución del presente Aviso Legal se interpretará
                          bajo la legislación española.
                        </p>
                        <p>
                          Asimismo, VOLKSWAGEN FINANCIAL SERVICES y el Usuario,
                          con renuncia a cualquier otro fuero, se someten al de
                          los juzgados y tribunales del domicilio del Usuario
                          para cualquier controversia que pudiera surgir. En el
                          caso de que el Usuario tenga su domicilio fuera de
                          España, VOLKSWAGEN FINANCIAL SERVICES y el Usuario se
                          someten a los juzgados y tribunales de la ciudad de
                          Madrid.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="c-accordion__header  js-accordion__title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                  <button
                    className="c-accordion__title-label js-accordion__title-label"
                    aria-expanded="false"
                    type="button"
                  >
                    <span className="c-accordion__title-label-text">
                      Política de uso de&nbsp;cookies
                    </span>
                  </button>
                </h3>
              </div>
              <div
                className="c-accordion__panel js-accordion__panel js-is-fx js-is-ready is-closed"
                aria-hidden="true"
                style={accordionStyle}
              >
                <div className="c-accordion__content">
                  <div className="text parbase">
                    <div className="o-page-wrap">
                      <div className="c-list-nested-counter">
                        <p>
                          Se advierte al Usuario que este sitio Web utiliza
                          cookies. Las cookies son pequeños archivos de texto
                          que se instalan en el navegador del ordenador del
                          Usuario para registrar su actividad, enviando una
                          identificación anónima que se almacena en el mismo,
                          con la finalidad de que la navegación sea más
                          sencilla, permitiendo, por ejemplo, el acceso a los
                          Usuarios que se hayan registrado previamente y el
                          acceso a las áreas, servicios, promociones o concursos
                          reservados exclusivamente a ellos sin tener que
                          registrarse en cada visita. Se pueden utilizar también
                          para medir la audiencia, parámetros del tráfico y
                          navegación, tiempo de sesión, y/o controlar el
                          progreso y el número de entradas.
                        </p>
                        <p>
                          Volkswagen Financial Services procurará en todo
                          momento establecer mecanismos adecuados para obtener
                          el consentimiento del Usuario para la instalación de
                          cookies que lo requieran.
                        </p>
                        <p>
                          Haga clic{" "}
                          <a
                            title="cookies vwfs"
                            href="https://marketing.adobe.com/resources/help/es_ES/whitepapers/cookies/cookies_analytics.html"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            aquí
                          </a>
                          &nbsp;para obtener más información sobre las
                          cookies.&nbsp;
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="c-list-nested-counter u-mt-large">
              <p>
                Sin perjuicio de lo anterior, el Usuario tiene la posibilidad de
                configurar su navegador para ser avisado de la recepción de
                cookies y para impedir su instalación en su equipo. No obstante,
                la desactivación de las cookies puede afectar al correcto
                funcionamiento de determinadas secciones de la página web.
              </p>
              <p>
                Por favor, consulte las instrucciones y manuales de su navegador
                para ampliar esta información:
              </p>
              <ul /*style="list-style-position: inside;"*/>
                <li>
                  Si utiliza Microsoft Internet Explorer, en la opción de menú
                  Herramientas seleccionando Opciones de Internet y accediendo a
                  Privacidad.&nbsp;
                </li>
                <li>
                  Si utiliza Firefox para Mac en la opción de menú Preferencias,
                  seleccionando Privacidad, accediendo al apartado Mostrar
                  Cookies, y para Windows en la opción de menú Herramientas,
                  seleccionando Opciones, accediendo a Privacidad y luego a Usar
                  una configuración personalizada para el historial.&nbsp;
                </li>
                <li>
                  Si utiliza Safari, en la opción de menú Preferencias,
                  seleccionando Privacidad&nbsp;
                </li>
                <li>
                  Si utiliza Google Chrome, en la opción de menú Herramientas,
                  seleccionando Opciones (Preferencias en Mac), accediendo a
                  Avanzadas y luego en la opción Configuración Contenido de la
                  sección Privacidad, y finalmente marcando Cookies en el
                  diálogo Configuración de contenido.
                </li>
              </ul>
              <p>
                Puede ocurrir que algunas cookies utilizadas en este sitio Web
                no estén relacionadas con Volkswagen Financial Services. Ello se
                debe a que algunas páginas del sitio web tienen insertado
                contenido procedente de webs de terceras partes (como por
                ejemplo, un vídeo de YouTube). Debido a que el referido
                contenido procede de otra web, Volkswagen Financial Services no
                controla la configuración de dichas cookies. Si Usted quiere
                cambiar sus preferencias de configuración de cookies, deberá
                consultar los sitios web de dichas terceras partes para obtener
                información.
              </p>
              <p>
                Por último, le informamos de que tiene la posibilidad de revocar
                en cualquier momento el consentimiento prestado para la
                utilización de cookies por parte de Volkswagen Financial
                Services, configurando para ello su navegador en los términos
                previstos en el punto anterior.
              </p>
            </div>
          </div>
        </section>
      </main>
    </Fragment>
  );
};
export default withCookies(withRouter(LegalNotePage));
